import {
  Box,
  IconButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import { PanelWrapper } from '../../components/shared/PanelWrapper/PannelWrapper';
import { FilterContainer } from '../../components/shared/Filter/FilterContainer';
import { CalendarIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { useQuery } from '../../utils/hooks/useQuery';
import { ResearcherViewModel } from '../../types/models';
import { useState } from 'react';
import { ResearcherModal } from '../../components/Researchers/ResearcherModal';
import { DeleteConfirmationPopover } from '../../components/shared/Popover/DeleteConfirmationPopover';
import { toast } from 'react-toastify';
import { useApiCall } from '../../utils/hooks/useApiCall';
import { deleteResearcher } from '../../services/researchersServices';
import { AgendaModal } from '../../components/Researchers/AgendaModal';

const columns = [
  { label: 'ID', key: 'id' },
  { label: 'Nome Pessoa', key: 'people.name' },
  { label: 'Documento', key: 'document' },
  { label: 'CRM', key: 'crm' },
  { label: 'Ações', key: 'actions' },
];

export const ResearchersPage = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAgenda,
    onOpen: onOpenAgenda,
    onClose: onCloseAgenda,
  } = useDisclosure();

  const [researcherData, setResearcher] = useState<
    ResearcherViewModel | undefined
  >();
  const [researcherLoading, setResearcherLoading] = useState(false);
  const { data: researchers, refetch } =
    useQuery<ResearcherViewModel[]>('/researchers');
  const api = useApiCall();

  const handleClose = () => {
    setResearcher(undefined);
    onClose();
  };

  const handleOpenEditModal = (usr: ResearcherViewModel) => {
    setResearcher(usr);
    onOpen();
  };

  const handleOpenAgendaModal = (usr: ResearcherViewModel) => {
    setResearcher(usr);
    onOpenAgenda();
  };

  const handleDelete = async (researcherId: number) => {
    try {
      setResearcherLoading(true);
      await deleteResearcher(researcherId, api);
      refetch();
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setResearcherLoading(false);
    }
  };

  return (
    <>
      <AgendaModal
        isOpen={isOpenAgenda}
        onClose={onCloseAgenda}
        refetch={refetch}
        researcher={researcherData}
      />
      <ResearcherModal
        researcher={researcherData}
        refetch={refetch}
        isOpen={isOpen}
        onClose={handleClose}
      />
      <PanelWrapper title="Investigadores">
        <FilterContainer onOpenModal={onOpen} />
        <Box className="rounded-lg shadow p-4 pt-10 mt-5">
          <Table>
            <Thead>
              <Tr>
                {columns.map((column) => (
                  <Th key={column.key}>{column.label}</Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {researchers?.map((row) => (
                <Tr
                  key={row.id}
                  className="hover:bg-gray-50 hover:cursor-pointer"
                >
                  <Td>{row.id}</Td>

                  <Td>{row.people?.name}</Td>
                  <Td>{row.people?.document}</Td>
                  <Td>{row.crm}</Td>
                  <Td>
                    <div className="w-full flex justify-around">
                      <DeleteConfirmationPopover
                        loading={researcherLoading}
                        onConfirm={() => handleDelete(row.id)}
                      >
                        <IconButton
                          colorScheme="red"
                          aria-label="Excluir"
                          icon={<DeleteIcon color="white" />}
                        />
                      </DeleteConfirmationPopover>{' '}
                      <IconButton
                        onClick={() => handleOpenEditModal(row)}
                        colorScheme="blue"
                        aria-label="Editar"
                        icon={<EditIcon color="white" />}
                      />
                      <IconButton
                        onClick={() => handleOpenAgendaModal(row)}
                        colorScheme="blue"
                        aria-label="Agenda"
                        icon={<CalendarIcon color="white" />}
                      />
                    </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </PanelWrapper>
    </>
  );
};
